<template>
  <div class="deliverylist">
    <headd :mobile_title="mobile_title"></headd>
    <div class="order_list container">
      <div class="coupon_title hidden-sm hidden-xs">资料寄送</div>
      <!-- <view class="order_title">资料寄送全部订单</view> -->
      <div class="order_item" v-for="(item, index) in Expresslist" :key="index">
        <div class="item_head" @click="open" :data-index="index">
          <div class="head_name">{{ item.createdAt }}资料寄送成功</div>
          <div class="head_status">
            {{ item.showstatus
            }}<img class="s_icon" src="../../../static/user/icon_13.png" />
          </div>
        </div>
        <div class="item_con" v-show="index == isChange">
          <div class="con_cell">
            <div class="cell_name">物品详细：</div>
            <div class="cell_vaule">{{ item.itemdesc }}</div>
          </div>
          <div class="con_cell">
            <div class="cell_name">快递：</div>
            <div class="cell_vaule">
              {{ item.express_company }} {{ item.express_no }}
            </div>
          </div>
          <div class="con_cell">
            <div class="cell_name">快递费用：</div>
            <div class="cell_vaule">{{ item.express_price }} 元</div>
          </div>
          <div class="con_cell">
            <div class="cell_name">寄件人：</div>
            <div class="cell_vaule">{{ item.sender }}</div>
          </div>
          <div class="con_cell">
            <div class="cell_name">电话：</div>
            <div class="cell_vaule">{{ item.sender_tel }}</div>
          </div>
          <div class="con_cell">
            <div class="cell_name">寄件地址：</div>
            <div class="cell_vaule">{{ item.sender_address }}</div>
          </div>
          <div class="con_cell">
            <div class="cell_name">收件人：</div>
            <div class="cell_vaule">{{ item.recipient }}</div>
          </div>
          <div class="con_cell">
            <div class="cell_name">电话：</div>
            <div class="cell_vaule">{{ item.recipient_tel }}</div>
          </div>
          <div class="con_cell">
            <div class="cell_name">收件地址：</div>
            <div class="cell_vaule">{{ item.recipient_address }}</div>
          </div>
          <div class="con_cell">
            <div class="cell_name">提交时间：</div>
            <div class="cell_vaule">{{ item.createdAt }}</div>
          </div>
          <div
            class="btn_save_red"
            v-if="item.openButon == 1"
            @click="btn_confirm(item.id)"
          >
            确认接收
          </div>
        </div>
      </div>
      <div class="gomore" @click="morelist" v-show="!flag">加载更多</div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import headd from "@/components/head";
import foot from "@/components/foot";
import { getitemExpressDetail, getitemExpressGetok } from "../api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      mobile_title: "资料寄送",
      status_open: false,
      isChange: -1,
      Express: {},
      pageindex: 1,
      flag: false,
      Expresslist: []
    };
  },
  components: {
    headd,
    foot
  },
  mounted() {
    this.getExpresslist();
  },
  methods: {
    async getExpresslist() {
      var _slef = this;
      var data = {
        uid: localStorage.getItem("userId"),
        page: _slef.pageindex,
        limit: 10
      };
      const res = await getitemExpressDetail(data);

      _slef.Expresslist = _slef.Expresslist.concat(res.data.data.express);

      if (res.data.data.express.length < 10) {
        _slef.flag = true;
      }
    },
    open(e) {
      var _self = this;
      var index = e.currentTarget.dataset.index;
      if (index != _self.isChange) {
        _self.isChange = index;
      } else {
        _self.isChange = -1; //不注释则可以点击取消，注释之后点击就不再取消
      }
    },
    adddelivery() {
      uni.navigateTo({
        url: "adddelivery"
      });
    },
    async btn_confirm(id) {
      var _self = this;

      this.$confirm("是否确定接收", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          _self.confirm(id);
        })
        .catch(() => {});
    },

    async confirm(id) {
      var _self = this;
      var parm = {
        uid: localStorage.getItem("userId"),
        expressid: id
      };
      const res_new = await getitemExpressGetok(parm);

      if (res_new.status == 1) {
        this.$toast({
          type: "success",
          message: "确定成功!"
        });
        _self.Expresslist = [];
        _self.pageindex = 1;
        _self.flag = false;
        _self.getExpresslist();
      }
    },
    morelist() {
      if (!this.flag) {
        this.pageindex++;
        this.getExpresslist();
      }
    }
  },
  onShow() {
    this.Expresslist = [];
    this.pageindex = 1;
    (this.flag = false), this.getExpresslist();
  },
  onReachBottom() {
    if (!this.flag) {
      this.pageindex++;
      this.getExpresslist();
    }
  },
  onPullDownRefresh() {
    console.log("下拉刷新了");
    this.pageindex = 1;
    this.Expresslist = [];
    this.flag = false;
    setTimeout(() => {
      this.getExpresslist(() => {
        uni.stopPullDownRefresh();
      });
    }, 1000);
  }
};
</script>

<style lang="less">
page {
  padding-bottom: 0rpx;
}
.deliverylist {
  margin: 0 auto;
  flex-direction: column;
  text-align: left;
  .coupon_title {
    font-size: 0.26rem;
    margin: 0rem 0 0.32rem 0;
  }

  .order_list {
    width: 8rem;
    @media (max-width: 991px) {
      width: 6.86rem;
      padding: 0;
    }
    margin-top: 0.32rem;
    flex-direction: column;
    .order_title {
      height: 0.5rem;
      font-size: 0.2rem;
      color: #1b1c33;
      line-height: 0.37rem;
      margin-top: 0;
      margin-bottom: 0.2rem;
    }
    .order_item {
      flex-direction: column;
      background-color: rgba(196, 196, 204, 0.1);
      border-radius: 0.3rem;
      margin-bottom: 0.2rem;
      padding: 0.2rem 0;
      @media (max-width: 991px) {
        padding: 0;
      }
      cursor: pointer;
      .item_head {
        padding: 0 0.2rem;
        @media (max-width: 991px) {
          padding: 0.12rem 0.2rem;
        }

        align-items: center;
        justify-content: space-between;
        display: flex;
        .head_name {
          font-size: 0.16rem;
          font-weight: bolder;
          color: #1b1c33;
          line-height: 0.25rem;
          @media (max-width: 991px) {
            font-size: 0.3rem;
            line-height: 0.42rem;
          }
        }
        .head_status {
          font-size: 0.14rem;
          color: #1395ff;
          line-height: 0.25rem;
          align-items: center;
          @media (max-width: 991px) {
            font-size: 0.28rem;
            line-height: 0.42rem;
          }
          .s_icon {
            margin-left: 0.13rem;
            width: 0.2rem;
            height: 0.11rem;
          }
        }
      }
      .item_con {
        padding: 0.1rem 0.2rem;
        flex-direction: column;
        .con_cell {
          margin-bottom: 0.2rem;
          display: flex;
          .cell_name {
            font-size: 0.16rem;
            @media (max-width: 991px) {
              font-size: 0.28rem;
            }
            color: #5e5e66;
          }
          .cell_vaule {
            font-size: 0.16rem;
            @media (max-width: 991px) {
              font-size: 0.28rem;
            }
            color: #333;
          }
        }
      }
    }
  }
}

.btn_fixed {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100rpx;
  align-items: center;
  justify-content: center;
  background-color: #1395ff;
  color: #fff;
  font-size: 30rpx;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/view/delivery/deliverylist.vue